<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

(function ($) {

    $(document).ready(function() {
        customJs.init();
    });

    let customJs = {
        init: function() {
            this.initCopyToClipboard();
            this.initGalleryImagesSlick();
        },

        initCopyToClipboard: function() {
            let copyTextElement = $('[data-copy-text]');
            copyTextElement.each(function() {
                let self = $(this),
                    tooltip = self.find('.tooltip'),
                    timeoutId;

                self.on('click', () => {
                    let textToCopy = self.attr('data-copy-text');
                    if (textToCopy) {
                        navigator.clipboard.writeText(textToCopy).then(() => {
                            if (tooltip.length) {
                                tooltip.text('Copied!');
                                tooltip.attr('aria-live', 'assertive');

                                clearTimeout(timeoutId);
                                timeoutId = setTimeout(() => {
                                    tooltip.text('Copy');
                                    tooltip.removeAttr('aria-live');
                                }, 1000);
                            }
                        }).catch((err) => {
                            console.error('Could not copy text: ', err);
                            if (tooltip.length) {
                                tooltip.text('Error');
                                timeoutId = setTimeout(() => {
                                    tooltip.text('Copy');
                                }, 1000);
                            }
                        });
                    }
                });
            });
        },
        initGalleryImagesSlick: function() {
            // Initialize slick slider for gallery images (blog posts)
            $('.gallery-images').each(function() {
                let data = $(this).data('slick');
                $(this).slick(data);
            });
        }
    }
})(jQuery);